/**
 * `loans-thin.type` stores a processing-checklist type id (e.g. "usa-purchase"),
 * not something readable. This mirrors backend
 * config/processing-checklist/PROCESSING_CHECKLIST_TYPES.js so the audit feed can
 * show "Conventional Purchase" instead of the raw id. Unknown ids pass through
 * unchanged, which keeps free-text `loans.type` values (LOS labels) intact.
 */
const CHECKLIST_TYPE_LABELS = {
  // United States
  "usa-purchase": "Conventional Purchase",
  "usa-refinance": "Conventional Rate-and-Term Refinance",
  "conventional-cash-out-refinance": "Conventional Cash-Out Refinance",
  "usa-dscr": "DSCR",
  "fha-purchase": "FHA Purchase",
  "fha-rate-and-term-refinance": "FHA Rate-and-Term Refinance",
  "fha-cash-out-refinance": "FHA Cash-Out Refinance",
  "fha-streamline-refinance": "FHA Streamline Refinance",
  "usda-purchase": "USDA Purchase",
  "usda-rate-and-term-refinance": "USDA Rate-and-Term Refinance",
  "usda-streamlined-assist-refinance": "USDA Streamlined-Assist Refinance",
  "va-purchase": "VA Purchase",
  "va-rate-and-term-refinance": "VA Rate-and-Term Refinance",
  "va-cash-out-refinance": "VA Cash-Out Refinance",
  "va-irrrl": "VA IRRRL",
  "jumbo-purchase": "Jumbo Purchase",
  "jumbo-rate-and-term-refinance": "Jumbo Rate-and-Term Refinance",
  "jumbo-cash-out-refinance": "Jumbo Cash-Out Refinance",
  "bank-statement-purchase": "Bank Statement Purchase",
  "bank-statement-rate-and-term-refinance":
    "Bank Statement Rate-and-Term Refinance",
  "bank-statement-cash-out-refinance": "Bank Statement Cash-Out Refinance",

  // Canada
  "canada-purchase-conventional": "Canada Purchase – Conventional",
  "canada-purchase-high-ratio": "Canada Purchase – High-Ratio (Insured)",
  "canada-purchase-insurable": "Canada Purchase – Insurable",
  "canada-purchase-uninsurable": "Canada Purchase – Uninsurable",
  "canada-purchase-rental": "Canada Purchase – Rental / Investment",
  "canada-purchase-construction-completion":
    "Canada Purchase – Construction Completion (Single Advance)",
  "canada-purchase-construction-progress-draw":
    "Canada Purchase – Construction Progress Draw",
  "canada-refinance-conventional": "Canada Refinance – Conventional",
  "canada-refinance-blend-extend":
    "Canada Refinance – Blend-and-Extend / Blended Rate",
  "canada-refinance-insurable": "Canada Refinance – Insurable",
  "canada-refinance-uninsurable": "Canada Refinance – Uninsurable",
  "canada-refinance-equity-takeout": "Canada Refinance – Equity Takeout",
  "canada-refinance-rental": "Canada Refinance – Rental / Investment",
  "canada-switch-transfer": "Canada Switch / Transfer (No New Funds)",
  "canada-switch-with-new-funds": "Canada Switch – With New Funds",
  "canada-construction-completion":
    "Canada Construction – Completion (Single Advance)",
  "canada-construction-progress-draw": "Canada Construction – Progress Draw",
  "canada-heloc": "Canada HELOC",
  "canada-bridge": "Canada Bridge Loan",
  "canada-reverse-mortgage": "Canada Reverse Mortgage",
  "canada-purchase-b-lender": "Canada Purchase – B-Lender",
  "canada-refinance-b-lender": "Canada Refinance – B-Lender",
  "canada-purchase-private": "Canada Purchase – Private Mortgage",
  "canada-refinance-private": "Canada Refinance – Private Mortgage",
  "canada-fthbi": "Canada First-Time Home Buyer Incentive",
  "canada-cmhc-green-home": "Canada CMHC Green Home Program",
  "canada-newcomer": "Canada Newcomer Mortgage Program",
  "canada-assumption": "Canada Mortgage Assumption",
  "canada-blended-rate": "Canada Blend-and-Extend / Blended Rate",
};

export function checklistTypeToLabel(loanType) {
  if (!loanType) return "";

  return CHECKLIST_TYPE_LABELS[loanType] || loanType;
}
